import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accroche',
  templateUrl: './accroche.component.html',
  styleUrls: ['./accroche.component.scss']
})
export class AccrocheComponent implements OnInit {

  public fiabilite  = 'hide';
  public simplicite = 'hide';
  public discretion = 'hide';
  public esp1: string;
  public esp2: string;
  public esp3: string;
  constructor() { }

  ngOnInit() {
  }

  toggleFiabilite() {
    if (this.fiabilite === 'hide') {
      this.fiabilite = 'block';
      this.esp2 = 'rotate';
    } else {
      this.fiabilite = 'hide';
      this.esp2 = '';
    }
  }

  toggleSimplicite() {
    if (this.simplicite === 'hide') {
      this.simplicite = 'block';
      this.esp1 = 'rotate';
    } else {
      this.simplicite = 'hide';
      this.esp1 = '';
    }
  }

  toggleDiscretion() {
    if (this.discretion === 'hide') {
      this.discretion = 'block';
      this.esp3 = 'rotate';
    } else {
      this.discretion = 'hide';
      this.esp3 = '';
    }
  }

}



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/components/home/accroche/accroche.component.ts